export default function() {
	return {
		title: this.$t("WordscapesErrorPageMetaTitle"),
		meta: [
			{
				name: "description",
				content: this.$t("WordscapesErrorPageMetaDescription"),
			},
			{
				name: "robots",
				content: "noindex",
			},
		],
	};
}
